<form *ngIf="form" [formGroup]="form" class="fields-container">
  <!-- By now, no cyclic simulations can be done
  <div class="toggle-container">
    <mat-slide-toggle formControlName="cyclic" [checked]="isCyclic">
      {{ T_SCOPE + '.labels.cyclic' | translate }}
    </mat-slide-toggle>
  </div>
  -->
  <mat-form-field [appearance]="fieldAppearance" class="field-stretch">
    <mat-label>{{ T_SCOPE + '.labels.snapshot' | translate }}</mat-label>
    <mat-select formControlName="snapshotId">
      <mat-option *ngFor="let option of snapshotOptions" [value]="option.value">
        {{ option.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field [appearance]="fieldAppearance" class="field-stretch">
    <mat-label>{{ T_SCOPE + '.labels.scenarios' | translate }}</mat-label>
    <mat-select formControlName="scenarioIds" multiple>
      <mat-option *ngFor="let option of scenarioOptions" [value]="option.value">
        {{ option.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field [appearance]="fieldAppearance" [class]="fieldClass" [floatLabel]="floatLabel">
    <mat-label>{{ T_SCOPE + '.labels.time-step-max' | translate }}</mat-label>
    <input type="number" matInput formControlName="timeStepMax" />
  </mat-form-field>
  <mat-form-field [appearance]="fieldAppearance" [class]="fieldClass" [floatLabel]="floatLabel">
    <mat-label>{{ T_SCOPE + '.labels.time-step-min' | translate }}</mat-label>
    <input type="number" matInput formControlName="timeStepMin" />
  </mat-form-field>

  <mat-form-field
    *ngIf="isCyclic"
    [appearance]="fieldAppearance"
    [class]="fieldClass"
    [floatLabel]="floatLabel"
    class="field-with-hint"
  >
    <mat-label>{{ T_SCOPE + '.labels.cycle' | translate }}</mat-label>
    <input matInput formControlName="cycle" daysMask autocomplete="off" />
    <mat-hint>{{ dayTimeHint }}</mat-hint>
  </mat-form-field>

  <mat-form-field
    *ngIf="isCyclic"
    [appearance]="fieldAppearance"
    [class]="fieldClass"
    [floatLabel]="floatLabel"
    class="field-with-hint"
  >
    <mat-label>{{ T_SCOPE + '.labels.period' | translate }}</mat-label>
    <input matInput formControlName="period" daysMask autocomplete="off" />
    <mat-hint>{{ dayTimeHint }}</mat-hint>
  </mat-form-field>

  <mat-form-field
    *ngIf="!isCyclic"
    [appearance]="fieldAppearance"
    [class]="fieldClass"
    [floatLabel]="floatLabel"
  >
    <mat-label>{{ T_SCOPE + '.labels.date' | translate }}</mat-label>
    <input matInput [matDatepicker]="picker" autocomplete="off" formControlName="date" />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker [touchUi]="false"></mat-datepicker>
  </mat-form-field>

  <mat-form-field
    *ngIf="!isCyclic"
    [appearance]="fieldAppearance"
    [class]="fieldClass"
    [floatLabel]="floatLabel"
    class="field-with-hint"
  >
    <mat-label>{{ T_SCOPE + '.labels.start-time' | translate }}</mat-label>
    <input matInput formControlName="startTime" daysMask autocomplete="off" />
    <mat-hint>{{ dayTimeHint }}</mat-hint>
  </mat-form-field>

  <mat-form-field
    *ngIf="!isCyclic"
    [appearance]="fieldAppearance"
    [class]="fieldClass"
    [floatLabel]="floatLabel"
    class="field-with-hint"
  >
    <mat-label>{{ T_SCOPE + '.labels.stop-time' | translate }}</mat-label>
    <input matInput formControlName="stopTime" daysMask autocomplete="off" />
    <mat-hint>{{ dayTimeHint }}</mat-hint>
  </mat-form-field>
  <div class="simulate-buttons">
    <button
      mat-raised-button
      class="wtr-action-button-primary simulate-button"
      [disabled]="isExternalDisabled || !isValid"
      [matTooltip]="T_SCOPE + '.buttons.start' | translate | lowercase"
      (click)="onStartSimulation()"
    >
      <!--<wlm-icon [icon]="'play_arrow'"></wlm-icon>-->
      {{ T_SCOPE + '.buttons.start' | translate }}
    </button>
    <button
      mat-raised-button
      class="wtr-action-button-error simulate-button"
      [disabled]="isExternalDisabled || !isValid"
      [matTooltip]="T_SCOPE + '.buttons.stop' | translate | lowercase"
      (click)="onStopSimulation()"
    >
      <!--<wlm-icon [icon]="'stop'"></wlm-icon>-->
      {{ T_SCOPE + '.buttons.stop' | translate }}
    </button>
  </div>
</form>
